(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore',
            'jquery',
            'torso/modules/NestedModel',
            'services/patientExtService'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('underscore'),
                             require('jquery'),
                             require('backbone-torso/modules/NestedModel'),
                             require('./../urls').patientExtService);
    } else {
      throw 'Only AMD and CommonJS imports are supported.';
    }
  }(this, function (_, $, TorsoNestedModel, patientExtService) {
  'use strict';

  /**
   * Model representing patient insurance information.
   * @class PatientInsuranceModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    idAttribute: 'externalId',
    urlRoot: function() {
      return patientExtService + '/' + this._patientVecnaId + '/insurance';
    },

    /**
     * @method initialize
     * @param attributes {Object}
     * @param options {Object}
     *   @param options.patientVecnaId {String} the patient vecna id
     * @override
     */
    initialize: function(attributes, options) {
      options = options || {};
      this.setPatientVecnaId(options.patientVecnaId);
    },

    /**
     * Updates the patient id to a new value.
     * @method setPatientVecnaId
     * @param patientVecnaId the vecna id of the patient
     */
    setPatientVecnaId: function(patientVecnaId) {
      this._patientVecnaId = patientVecnaId;
    }
  });
}));
